module.exports = __webpack_public_path__ + "img/blankscreen_1000.9a81bcd3.jpg";